import { render, staticRenderFns } from "./WaterFaultAlarm.vue?vue&type=template&id=c8394420&scoped=true"
import script from "./WaterFaultAlarm.vue?vue&type=script&lang=js"
export * from "./WaterFaultAlarm.vue?vue&type=script&lang=js"
import style0 from "./WaterFaultAlarm.vue?vue&type=style&index=0&id=c8394420&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8394420",
  null
  
)

export default component.exports